module.exports = __webpack_public_path__ + "media/images/ticket/navi_tirashi-ac67c3a4b4e8a2076b17258d138f46be.png";